import { useQuery } from '@tanstack/react-query';
import { UserInsideArea, UsersInsideAreaFilter } from '@models/usersInsideArea.model';
import { usersInsideAreaService } from '@services/usersInsideArea';

export const USERS_INSIDE_AREA_QUERY_KEY = ['usersInsideArea'];

const REFRESH_INTERVAL_MS = 30_000;

interface UseUsersInsideAreaOptions {
  /** Pause refetching when the drawer is closed */
  enabled?: boolean;
}

export const useUsersInsideArea = (
  filter: UsersInsideAreaFilter | null,
  options: UseUsersInsideAreaOptions = {},
) => {
  const { enabled = true } = options;
  const hasFilter = !!(filter?.projectId || filter?.geofenceId);

  return useQuery<UserInsideArea[], Error>({
    queryKey: [...USERS_INSIDE_AREA_QUERY_KEY, filter],
    queryFn: async () => {
      if (!filter) return [];
      const items = await usersInsideAreaService.getUsersInsideArea(filter);
      return items || [];
    },
    enabled: enabled && hasFilter,
    refetchInterval: enabled && hasFilter ? REFRESH_INTERVAL_MS : false,
    refetchIntervalInBackground: false,
  });
};

export default useUsersInsideArea;
